module.exports = __webpack_public_path__ + "img/dollar-sign.cbeab270.svg";